import React, { useState, useEffect } from 'react';
import '../NavigatieBar/Styles.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NavigatieBar = () => {
  const [menuActive, setMenuActive] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  const toggleSubmenu = (menu) => {
    setOpenSubmenu(openSubmenu === menu ? null : menu);
  };

  const handleLinkClick = (url) => {
    setMenuActive(false);
    setOpenSubmenu(null);

    if (location.pathname === url) {
      if (url === '/') {
        window.scrollTo(0, 0);
      } else if (url === '/overons') {
        document.getElementById('overOns')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (url === '/aanbod') {
        document.getElementById('onsAanbod')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      navigate(url);
    }
  };

  useEffect(() => {
    if (location.pathname === '/overmb') {
      setTimeout(() => {
        document.getElementById('overOns')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    } else if (location.pathname === '/aanbod') {
      setTimeout(() => {
        document.getElementById('onsAanbod')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  }, [location]);

  return (
    <header>
      <Link to='/' onClick={() => handleLinkClick('/')} className="logo">
        <img
          src="/images/MindfulBreaks_Logo_CMYK_brandmark_White.png"
          className="logoMindfulBreaks"
          alt="logo of mindful breaks"
        />
        Mindful <span className='logoHeadingTitle'>Breaks</span>
      </Link>

      <nav>
        <ul className={`nav__links ${menuActive ? 'active' : ''}`}>
          <li><Link to="/" onClick={() => handleLinkClick('/')}>HOME</Link></li>
          <li><Link to="/overmij" onClick={() => handleLinkClick('/overmij')}>OVER MIJ</Link></li>

          {/* AANBOD */}
          <li className={`has-submenu ${openSubmenu === 'aanbod' ? 'open' : ''}`}>
            <span className="products-link" onClick={() => toggleSubmenu('aanbod')}>
              AANBOD
              <span className={`dropdown-icon ${openSubmenu === 'aanbod' ? 'rotate' : ''}`}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </span>

            <ul className="submenu">
              <li className={`has-submenu ${openSubmenu === 'aanbod' ? 'open' : ''}`}>
                <Link to="/privelessen" onClick={() => handleLinkClick('/privelessen')}>
                  PRIVELESSEN
                </Link>
              </li>
              <li>
                <Link to="/yogavoorbedrijven" onClick={() => handleLinkClick('/yogavoorbedrijven')}>
                  YOGA VOOR BEDRIJVEN
                </Link>
              </li>
            </ul>
          </li>

          <li><Link to="/tarieven" onClick={() => handleLinkClick('/tarieven')}>TARIEVEN</Link></li>

          {/* MEER */}
          <li className={`has-submenu ${openSubmenu === 'meer' ? 'open' : ''}`}>
            <span className="products-link" onClick={() => toggleSubmenu('meer')}>
              MEER
              <span className={`dropdown-icon ${openSubmenu === 'meer' ? 'rotate' : ''}`}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </span>

            <ul className="submenu">
              <li>
                <Link to="/blog" onClick={() => handleLinkClick('/blog')}>
                  BLOG
                </Link>
              </li>
              <li>
                <Link to="/woordenboek" onClick={() => handleLinkClick('/woordenboek')}>
                  WOORDENBOEK
                </Link>
              </li>
              <li>
                <Link to="/watisyoga" onClick={() => handleLinkClick('/watisyoga')}>
                  WAT IS YOGA?
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link className='buttonNewContact' to="/contact" onClick={() => handleLinkClick('/contact')}>
              CONTACT
            </Link>
          </li>
        </ul>
      </nav>

      <div className={`toggle-button ${menuActive ? 'open' : ''}`} onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </header>
  );
};

export default NavigatieBar;